<ng-container *ngIf="visible">
    <mat-progress-bar attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}" color="accent" [bufferValue]="bufferValue" [mode]="mode" [value]="value"></mat-progress-bar>
</ng-container>
